import React, { useEffect } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import BannerRightImg from '../../../assets/Player_Portal/images/homeBanner.png'
import BannerLeftImg from '../../../assets/Player_Portal/images/cardsIllustration.png'
import nameCard from '../../../assets/Player_Portal/images/nameCards.png'
import PlayGames from '../../../assets/Player_Portal/images/playGames.png'
import BeWinner from '../../../assets/Player_Portal/images/beWinner.svg'
import EarnMoney from '../../../assets/Player_Portal/images/earnMoney.png'
import BgTransparent1 from '../../../assets/Player_Portal/images/transparwntImage-1.png'
import BgTransparent2 from '../../../assets/Player_Portal/images/transparwntImage-2.png'
import GinGame from '../../../assets/Player_Portal/images/3gin-game.png'
import CribbageGame from '../../../assets/Player_Portal/images/2cribbage-game.png'
import CardGame from '../../../assets/Player_Portal/images/1card-game.png'
import TexasGame from '../../../assets/Player_Portal/images/4texas-game.png'
import PrevBtn from '../../../assets/Player_Portal/images/prevArrow.svg'
import NextBtn from '../../../assets/Player_Portal/images/nextArrow.svg'
import FeaturedImg1 from '../../../assets/Player_Portal/images/featuredImg-1.png'
import FeaturedImg2 from '../../../assets/Player_Portal/images/featuredImg-2.png'
import FeaturedImg3 from '../../../assets/Player_Portal/images/featuredImg-3.png'
import LogoImg from '../../../assets/Player_Portal/images/logoImg.png'
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/react";
import { Link, useNavigate } from 'react-router-dom';


const LandingPage = () => {
 

    return (
        <>
            {/* Banner section starts here */}
            <section>
                <Container fluid className='bannerSection'>
                    <Row className='h-100'>
                        <Col className='position-relative'>
                            <img src={BannerLeftImg} className='img-fluid leftSideImg' alt="Image" />
                            <div className='bannerHead'>
                                <img src={BannerLeftImg} className='img-fluid leftSideImg' alt="Image" />
                                <div className='bannerHeading'>
                                    <h1>Monkey
                                        <img src={nameCard} className='img-fluid' alt="Image" />
                                        <span>Royale</span></h1>
                                    <h2 className='subHeading'>Unleash your card skills online</h2>
                                </div>
                                <div className='bannerInfo'>
                                    <h2>Your next winning move starts here</h2>
                                    <p className='text-white'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut <br /> labore et dolore magna aliqua</p>
                                </div>

                            </div>
                            <img src={BannerRightImg} className='img-fluid ms-auto rightSideImg' alt="Image" />
                        </Col>
                    </Row>
                </Container>

                {/* Banner section ends here */}    
                {/* Card section start from here */}
                <Container fluid className='cardSection position-relative'>
                    <img src={BgTransparent1} className='transparentImg1' alt="Transparent Image" />
                    {/* Play game and win cards starts here */}
                    <Container className='bg-transparent infoCards'>
                        <Row>

                            <Col md={4}>
                                <Card>
                                    <span className='cardIcons'>
                                        <img src={PlayGames} alt="" />
                                    </span>
                                    <h2 className='cardHead'>Play Games</h2>
                                    <p className='text-center'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </Card>
                            </Col>
                            <Col md={4}>
                                <Card>
                                    <span className='cardIcons'>
                                        <img src={BeWinner} alt="" />
                                    </span>
                                    <h2 className='cardHead'>Be a Winner!</h2>
                                    <p className='text-center'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </Card>
                            </Col>
                            <Col md={4}>
                                <Card>
                                    <span className='cardIcons'>
                                        <img src={EarnMoney} alt="" />
                                    </span>
                                    <h2 className='cardHead'>Earn Money!</h2>
                                    <p className='text-center'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                    {/*=================== Play game and win cards ends here ===================*/}
                    {/*=================== Featured Games section starts here ===================*/}
                    <Container fluid>
                        <Row className='featuredGames'>
                            <div className='featuredGamesHead mb-5'>
                                <div className='gamesHeading px-0'>
                                    <h3>Featured <span>Games</span> to play</h3>

                                    <div className='sliderBtn d-flex gap-2'>
                                        <button className="arrow-left arrow">
                                            <img src={PrevBtn} alt="Previous Button" />
                                        </button>
                                        <button className="arrow-right arrow">
                                            <img src={NextBtn} alt="Next Button" />
                                        </button>
                                    </div>
                                </div>
                                <p>The Best Card Games</p>
                            </div>


                            {/* slider starts */}
                            <Swiper
                                modules={[Navigation, Pagination, Scrollbar, A11y]}
                                spaceBetween={60}
                                slidesPerView={4}
                                navigation={{ nextEl: ".arrow-right", prevEl: ".arrow-left" }}
                                pagination={{ clickable: true }}
                                scrollbar={{ draggable: true }}
                                onSwiper={(swiper) => console.log(swiper)}
                                onSlideChange={() => console.log('slide change')}
                                className='flex-nowrap cardSlider overflow-hidden row'
                            >
                                <SwiperSlide className='col-4'>
                                    <Card className='p-0'>
                                        <Link to="/gingame" className='btn-container border-0 bg-transparent'> <img src={GinGame} className='img-fluid' alt="" /></Link>
                                    </Card>
                                </SwiperSlide>

                                <SwiperSlide className='col-4'>
                                    <Card className='p-0'>
                                        <Link to=""  className='btn-container border-0 bg-transparent'><img src={CribbageGame} className='img-fluid' alt="" /></Link>
                                    </Card>
                                </SwiperSlide>

                                <SwiperSlide className='col-4'>
                                    <Card className='p-0'>
                                        <Link to=""  className='btn-container border-0 bg-transparent'><img src={CardGame} className='img-fluid' alt="" /></Link>
                                    </Card>
                                </SwiperSlide>

                                <SwiperSlide className='col-4'>
                                    <Card className='p-0'>
                                        <Link to=""  className='btn-container border-0 bg-transparent'><img src={TexasGame} className='img-fluid' alt="" /></Link>
                                    </Card>
                                </SwiperSlide>

                                <SwiperSlide className='col-4'>
                                    <Card className='p-0'>
                                        <Link to="/gingame"><img src={GinGame} className='img-fluid' alt="" /></Link>
                                    </Card>
                                </SwiperSlide>

                                <SwiperSlide className='col-4'>
                                    <Card className='p-0'>
                                        <Link><img src={TexasGame} className='img-fluid' alt="" /></Link>
                                    </Card>
                                </SwiperSlide>


                            </Swiper>

                            {/* slider ends */}
                        </Row>
                    </Container>
                    {/* Featured Games section ends here */}
                    <img src={BgTransparent2} className='transparentImg2' alt="Transparent Image" />
                </Container>

                {/* ===================Featured articles section starts here ===================*/}
                <div fluid className='featuredArticlesSection'>
                    <Container>
                        <Row>
                            <Col xs={12}>
                                <div className='featuredArticles mb-5'>
                                    <div className='gamesHeading px-0'>
                                        <h3 className='text-center w-100'>Featured <span>Articles</span></h3>
                                    </div>
                                    <p className='text-center'>The Best Card Games</p>
                                </div>
                            </Col>

                            <Col md={4}>
                                <Card className='bg-transparent'>
                                    <img src={FeaturedImg1} className='img-fluid' alt="Images" />
                                    <div className='card-body'>
                                        <h2 className='text-center text-white'>Experience the real Cards game fun with us</h2>
                                        <p className='text-center text-muted'>September 05, 2023</p>
                                    </div>
                                </Card>
                            </Col>

                            <Col md={4}>
                                <Card className='bg-transparent'>
                                    <img src={FeaturedImg2} className='img-fluid' alt="Images" />
                                    <div className='card-body'>
                                        <h2 className='text-center text-white'>Experience the real Cards game fun with us</h2>
                                        <p className='text-center text-muted'>September 05, 2023</p>
                                    </div>
                                </Card>
                            </Col>


                            <Col md={4}>
                                <Card className='bg-transparent'>
                                    <img src={FeaturedImg3} className='img-fluid' alt="Images" />
                                    <div className='card-body'>
                                        <h2 className='text-center text-white'>Experience the real Cards game fun with us</h2>
                                        <p className='text-center text-muted'>September 05, 2023</p>
                                    </div>
                                </Card>
                            </Col>


                        </Row>
                    </Container>
                </div>
                {/*=================== Featured articles section ends here ===================*/}
                {/* new letter subscription section starts */}
                <Container fluid className='newsLetter'>
                    <Row className='justify-content-center align-items-center'>
                        <Col lg={5} md={12} className='d-flex'>
                            <h2 className='text-white text-center'>Subscribe for more <br />exclusive updates</h2>
                        </Col>
                        <Col lg={5} md={12} className='d-flex justify-content-end'>
                            <div className='newsFeedInput position-relative w-100 text-end'>
                                <input className='form-control' type="email" placeholder='Enter your email address' />
                                <button className='btn btn-subscribe'>SUBSCRIBE</button>
                            </div>
                        </Col>
                    </Row>
                </Container>
                {/* new letter subscription section ends */}

                <Container fluid className='landingFooter'>
                    <Row>
                        <Col lg={12}>
                            <img src={LogoImg} alt="Footer Image" />
                        </Col>
                        <Col lg={3} md={3} ><p className='text-white'>There is no one who loves pain itself, who <br />seeks after it and wants to have it, simply<br /> because it is pain</p></Col>
                        <Col lg={2} md={2}>
                            <ul className='list-unstyled'>
                                <li className='mb-3 mt-0'><Link className='text-decoration-none text-white' as={Link} to="/home"> Home </Link></li>
                                <li className='my-3'><Link className='text-decoration-none text-white' as={Link} to="/"> Support </Link></li>
                                <li className='my-3'><Link className='text-decoration-none text-white' as={Link} to="/"> Blogs </Link></li>
                                <li className='my-3'><Link className='text-decoration-none text-white' as={Link} to="/"> Games </Link></li>
                                <li className='mt-3 mb-0'><Link className='text-decoration-none text-white mt-2 mb-0' as={Link} to="/"> Resources </Link></li>
                            </ul>
                        </Col>
                        <Col lg={2} md={2}>
                            <ul className='list-unstyled'>
                                <li className='mb-3 mt-0'><Link className='text-decoration-none text-white' as={Link} to="/"> Company </Link></li>
                                <li className='my-3'><Link className='text-decoration-none text-white' as={Link} to="/"> About </Link></li>
                                <li className='my-3'><Link className='text-decoration-none text-white' as={Link} to="/"> How it works </Link></li>
                            </ul>
                        </Col>
                        <Col lg={2} md={2}>
                            <ul className='list-unstyled'>
                                <li className='mb-3 mt-0'><Link className='text-decoration-none text-white' as={Link} to="/"> Privacy </Link></li>
                                <li className='my-3'><Link className='text-decoration-none text-white' as={Link} to="/"> Code of Conduct </Link></li>
                                <li className='my-3'><Link className='text-decoration-none text-white' as={Link} to="/"> Terms & Conditions </Link></li>
                                <li className='my-3'><Link className='text-decoration-none text-white' as={Link} to="/"> Cookies </Link></li>
                            </ul>
                        </Col>
                        <Col lg={3} md={3}>
                            <div className='contactUs'>
                                <p className='text-white'>Call Us On</p>
                                <h4 className='text-white'>864-631-1137</h4>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default LandingPage;